import { Form } from "react-bootstrap";

import { useSelector } from "react-redux";
import { AppState } from "../../store/root.reducer";
import { FormEvent, useEffect, useState } from "react";
import { updateDefaultSpaceRequest } from "./store/admin.api";
import { AlertComponent } from "../../components/shared/alert.component";
import { useDispatch } from "react-redux";
import { GetDefaultSpace } from "./store/admin.actions";

export const System = () => {
    const dispatch = useDispatch();

    const [ successAlert, setSuccessAlert ] = useState<boolean>(false);
    const [ errorAlert, setErrorAlert ] = useState<boolean>(false);
    const [ saving, setSaving ] = useState<boolean>(false);
    const [ defaultSpace, setDefaultSpace ] = useState<string>('');

    const systemId = useSelector((state: AppState) => state.admin.systemId)

    const onSaveDefaultSpace = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setSaving(true);
        const { data } = await updateDefaultSpaceRequest(systemId, defaultSpace)
        if (data.status) {
            setSuccessAlert(true);
        } else {
            setErrorAlert(true);
        }

        setSaving(false);
    }

    useEffect(() => {
        (async () => {
            dispatch(GetDefaultSpace())
        })()
    }, [])

    return (
        <>
            <div className="container">
                {successAlert && <AlertComponent
                    onClose={setSuccessAlert}
                    text="Default space has been updated"
                    variant="success"
                />}

                {errorAlert && <AlertComponent
                    onClose={setErrorAlert}
                    text="Failed to update default space"
                    variant="danger"
                />}

                <Form onSubmit={onSaveDefaultSpace}>
                    <Form.Label>Default Linked Space</Form.Label>
                    <Form.Control
                        value={defaultSpace}
                        onChange={(e) => setDefaultSpace(e.target.value)}
                        type="text"
                        placeholder="Enter space ID"
                    />
                    <button type="submit" className="mt-1 btn btn-success" disabled={!defaultSpace || defaultSpace == "" || saving}>
                        Save
                    </button>
                </Form>
            </div>
        </>
    )
}